/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-hidden',
  templateUrl: './theme-option-elements-hidden.component.html',
  styleUrls: ['./theme-option-elements-hidden.component.css']
})
export class ThemeOptionElementsHiddenComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() serieIndex: number;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_hidden';

  constructor() {}

  receiveValue(value: boolean) {
    this.themeOptions.setSeries(this.optionType, value, this.serieIndex);
  }

}
